import { NavigationGuard } from 'vue-router'
import { can } from '@/composables/useGuard'
import { SettingsStore } from '@/composables/useSettings'
import { MergeKind } from '@/types/merge'

export const mergeGuard =
  (kind: MergeKind): NavigationGuard =>
  async (to, from, next) => {
    const settings = await SettingsStore.get()
    const enabled =
      kind === 'client' ? settings?.clients.merge : settings?.locations.merge

    if (!enabled || !can('merge records')) return next({ name: 'Forbidden' })

    next()
  }
